<template>
    <CoreTwoColumnsRow>
        <template #left>
            <CoreBorderWrapper
                :condensed="true"
                class="flex-grow-1 flex-shrink-1 flex-basis-55 flex space-between"
            >
                <div class="flex-1">
                    {{ $t('§eq_type.eq_type_currency') }}
                    {{ isFieldRequired('currency_code') }}
                </div>
                <CoreIcon
                    name="information-outline"
                    size="18"
                    class="ml-auto"
                    fillColor="var(--color-secondary-200)"
                    v-tooltip="{ value: $t('§eq_type.eq_type_currency_tooltip') }"
                />
            </CoreBorderWrapper>
        </template>
        <template #right>
            <CoreDropdown
                :validator="v$.currency_code"
                v-model="unitTypeStore.unitTypeData.currency_code"
                :options="currencyOptions"
                class="flex-grow-1 flex-shrink-1 flex-basis-45"
            />
        </template>
    </CoreTwoColumnsRow>

    <CoreTwoColumnsRow>
        <template #left>
            <CoreBorderWrapper
                :condensed="true"
                class="flex-grow-1 flex-shrink-1 flex-basis-55 flex space-between"
            >
                <div class="flex-1">
                    {{ $t('§eq_type.list_price') }}
                    {{ isFieldRequired('value') }}
                </div>
                <CoreIcon
                    name="information-outline"
                    size="18"
                    class="ml-auto"
                    fillColor="var(--color-secondary-200)"
                    v-tooltip="{ value: $t('§eq_type.list_price_tooltip') }"
                />
            </CoreBorderWrapper>
        </template>
        <template #right>
            <CoreCurrencyInput
                :validator="v$.value"
                :modelValue="unitTypeStore.unitTypeData.value"
                @update:modelValue="unitTypeStore.setValue"
                :maxFractionDigits="2"
                :disabled="unitTypeStore.calculating"
                class="flex-grow-1 flex-shrink-1 flex-basis-45"
                :currency="currencyCode"
            />
        </template>
    </CoreTwoColumnsRow>

    <CoreTwoColumnsRow class="mb-10">
        <template #left>
            <CoreBorderWrapper
                :condensed="true"
                class="flex-grow-1 flex-shrink-1 flex-basis-55 flex space-between"
            >
                <div class="flex-1">
                    {{ $t('§eq_type.refurbishment') }}
                    {{ isFieldRequired('refurbishment') }}
                </div>
                <CoreIcon
                    name="information-outline"
                    size="18"
                    class="ml-auto"
                    fillColor="var(--color-secondary-200)"
                    v-tooltip="{ value: $t('§eq_type.refurbishment_tooltip') }"
                />
            </CoreBorderWrapper>
        </template>
        <template #right>
            <CoreCurrencyInput
                :validator="v$.refurbishment"
                v-model="unitTypeStore.unitTypeData.refurbishment"
                :maxFractionDigits="2"
                class="flex-grow-1 flex-shrink-1 flex-basis-45"
                :currency="currencyCode"
            />
        </template>
    </CoreTwoColumnsRow>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'

import { useUnitTypeStore } from '@/stores/unitType'

import { useUserStore } from '@/stores/user'
import rules from '../validationRules.js'
import CoreTwoColumnsRow from '@/components/core/CoreTwoColumnsRow.vue'
import CoreBorderWrapper from '@/components/core/CoreBorderWrapper.vue'
import CoreDropdown from '@/components/core/CoreDropdown.vue'
import CoreCurrencyInput from '@/components/core/CoreCurrencyInput.vue'
import CoreIcon from '@/components/core/CoreIcon.vue'

export default {
    name: 'InputsPurchaseInfo',

    components: {
        CoreCurrencyInput,
        CoreDropdown,
        CoreBorderWrapper,
        CoreTwoColumnsRow,
        CoreIcon,
    },

    data() {
        return {
            unitTypeStore: useUnitTypeStore(),
            userStore: useUserStore(),
            v$: {},
        }
    },

    watch: {
        isValid: {
            handler(newValue) {
                this.unitTypeStore.isValidPurchaseInfo = newValue
            },
            immediate: true,
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.v$ = useVuelidate(rules, this.unitTypeStore.unitTypeData)
        })
    },

    computed: {
        isValid() {
            return (
                !this.v$.currency_code?.$invalid &&
                !this.v$.value?.$invalid &&
                !this.v$.refurbishment?.$invalid
            )
        },

        currencyCode() {
            return this.unitTypeStore.unitTypeData.currency_code || 'EUR'
        },

        currencyOptions() {
            return this.userStore.userData.allowed_currency_options
        },
    },
}
</script>
